import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import classNames from 'classnames';
import i18n from '../../i18n';
import Utils from '../../utils/utils';

import Tooltip from '../widget/Tooltip';

import AlertModel from '../../models/Alert';
import FiltersModel from '../../models/Filters';
import User from '../../models/User';
import Analytics from '../../utils/analytics';

export class Alert extends React.PureComponent {
    static propTypes = {
        user: PropTypes.instanceOf(User),
        alerts: PropTypes.arrayOf(PropTypes.instanceOf(AlertModel)),
        search: PropTypes.object.isRequired,
        iconOnly: PropTypes.bool,
        withTooltip: PropTypes.bool
    };

    constructor(props) {
        super(props);
        const { alerts, search } = props;
        this.state = {
            success: false,
            errorPopup: false,
            alert: this.getExistingAlert(alerts, search)
        };
        this.saveSearch = this.saveSearch.bind(this);
        this.buttonRef = React.createRef();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { alerts, search } = nextProps;
        this.setState({
            alert: this.getExistingAlert(alerts, search)
        });
    }

    getExistingAlert(alerts, search) {
        if (alerts && alerts.length > 0 && search) {
            const alert = AlertModel.fromSearch(search.query, search.filters);
            const searchParams = alert.get('params');
            return alerts.find((item) => _.isEqual(item.get('params'), searchParams));
        }
        return null;
    }

    saveSearch(event) {
        event.preventDefault();

        const { search, user } = this.props;
        const { alert } = this.state;

        if (!user) {
            $('.btn-signup').trigger('click');
            return;
        }

        Analytics.trackGTM('SearchResults', {
            event_data: {
                action: 'click',
                text: 'save_this_destination',
                area: 'search',
                search_parameter: 'save_this_destination',
                search_value: search.query
            }
        });

        if (alert) {
            const content = (
                <div>
                    <p>{i18n.t('search:destination.saved.text')}</p>
                    <p>
                        <a
                            href={`${i18n.t('user:user.edit.url', {
                                id: window.gtg.userId
                            })}#${Utils.slugify(i18n.t('user:preferred.destinations'))}`}
                        >
                            {i18n.t('search:destination.created.link')} <i className="fa fa-angle-right"></i>
                        </a>
                    </p>
                </div>
            );
            sweetAlert({
                icon: 'info',
                title: i18n.t('search:destination.saved.title'),
                content
            });
        } else {
            // eslint-disable-next-line camelcase
            const preferredDestinationFilters = (({ calendar, home, location, filters, luxury }) => ({
                calendar,
                home,
                location,
                filters,
                luxury
            }))(search.filters);
            const preferredDestinationParams = new FiltersModel(preferredDestinationFilters).params();

            // Just allows those filters for keeping good result in the alert
            const allowAlertFilter = [
                'pets-welcome',
                'children-welcome',
                'smokers-welcome',
                'disabled-access',
                'home-verified',
                'home-with-picture',
                'response-rate-above-threshold',
                'no-bed-up'
            ];

            preferredDestinationParams.filter = preferredDestinationParams.filter.filter((el) =>
                allowAlertFilter.includes(el)
            );
            delete preferredDestinationParams.reciprocal;
            delete preferredDestinationParams.home_type;
            delete preferredDestinationParams.is_primary;

            if (search.query) {
                preferredDestinationParams.address = search.query;
            }

            const baseUrl = `${i18n.t('user:user.edit.url', { id: window.gtg.userId })}`;
            const params = $.param(preferredDestinationParams);
            const url = `${baseUrl}?${params}#preferred-destination-form`;
            return document.location.assign(url);
        }
    }

    render() {
        const { user } = this.props;
        const { alert } = this.state;

        if (!user) {
            return null;
        }

        if (!this.props.search.query || this.props.search.query.length === 0) {
            return null;
        }

        if (alert) {
            return (
                <a href="#" className="btn btn-alert saved" onClick={this.saveSearch} ref={this.buttonRef}>
                    <i className="icon icon-ok surrounded" />
                    <span className="btn-alert-text">{i18n.t('search:destination.saved')}</span>
                </a>
            );
        }
        const button = (
            <a
                ref={this.buttonRef}
                className={classNames('btn btn-default', { 'btn-icon-only': this.props.iconOnly })}
                href="#"
                onClick={this.saveSearch}
            >
                <i className="icon-preferred-destinations btn-alert" />
                <span className="btn-alert-text">{i18n.t('search:destination.save')}</span>
            </a>
        );
        if (this.props.withTooltip) {
            return (
                <Tooltip title={i18n.t('search:destination.tooltip')} placement="bottom" container={false}>
                    {button}
                </Tooltip>
            );
        }
        return button;
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    homes: state.homes,
    alerts: state.savedSearches
});

export default connect(mapStateToProps)(Alert);
